<template>
  <div class="row">
    <div class="col-12 col-md-12">
      <div
              class="alert alert-warning"
              role="alert"
              style="background-color: rgba(248, 214, 43, 0.3);color:#000;"
            ><i class="fa fa-exclamation-triangle"></i>
        <label><b>Indicaciones:</b></label>
        <p class="font-weight-bold">
          Comunicar al ciudadano extranjero que debe declarar la dirección 
          donde se hospedará en un máximo de 48 horas una vez realizado su ingreso
          al territorio boliviano en el Sistema de Gestión Migratoria "SIGEMIG"
        </p>
      </div>
    </div>
  </div>  
</template>

<script>
export default {

}
</script>

